import { Option } from '~/shared/config/constants'

export const groupOptionsByKey = <T extends Option>(
  groupKey: string,
  options: T[],
) => {
  return Object.entries(
    options.reduce((data: Record<string, T[]>, item) => {
      // TODO: доработать тип получение item по groupKey
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const groupItem = item[groupKey]

      if (!data[groupItem]) {
        data[groupItem] = []
      }

      data[groupItem].push(item)
      return data
    }, {}),
  )
}
